import { render, staticRenderFns } from "./cuentasBancarias.vue?vue&type=template&id=818fa1a6&scoped=true"
import script from "./cuentasBancarias.vue?vue&type=script&lang=js"
export * from "./cuentasBancarias.vue?vue&type=script&lang=js"
import style0 from "./cuentasBancarias.vue?vue&type=style&index=0&id=818fa1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818fa1a6",
  null
  
)

export default component.exports